import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { useStore } from '../../store';

interface IAbTestData {
    customerProfilesEnumList: string[];
    name: string;
    selected: string;
}

interface IDataResponse {
    lastLoginTime: Date;
    lastWebLoginTime: Date;
    features: {abTestData: IAbTestData[] };
}

const fetchData = async (customerId: string) => {
  const { data } = await httpService.get(`${BASE_URL}/api/v3/user/${customerId}/initialize`);
  return data as IDataResponse;
};

export const useInitializeApiQuery = (customerId: string) => {
  const currUser = useStore(state => state.user);
  const setUser = useStore(state => state.setUser);
  return useQuery(

    'initializeData',
    async () => {
      const data = await fetchData(customerId);
      setUser({ ...currUser, filteredInitializeArr: data?.features?.abTestData });
    },
    {
      cacheTime: 0,
      enabled: false,
    },
  );
};
